import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-18" data-mp="pjg4xyy2x3zv">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-19" data-mp="avcv2egx185s">
          🎁 5 BONUS PROFESSIONNELS <span className="text-tech" data-id="element-20" data-mp="ftmr0ragscsg">INCLUS</span>
        </h2>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-21" data-mp="frtkdbzupskg">
          {bonuses.map((bonus, i) => <article key={bonus.label} className={`rounded-xl border border-metal border-l-4 border-l-gold bg-white p-3 shadow-sm sm:p-4 ${i === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-22" data-mp="5w0ay1hfif6w" data-mpi={i}>
              <h3 className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm leading-tight text-navy sm:text-base" data-id="element-23" data-mp="3t1801m7ii42a">
                <span className="rounded-md bg-gold px-2 py-0.5 font-display text-xs font-extrabold tracking-wide text-navy" data-id="element-24" data-mp="1m8fdzg6hm9t4">
                  {bonus.label}
                </span>
                <span data-id="element-25" data-mp="3iclndrr6aixt">— {bonus.title}</span>
              </h3>
              <p className="mt-1 font-display text-xs font-bold uppercase text-tech" data-id="element-26" data-mp="3dg4y2u88lyj5">
                {bonus.subtitle}
              </p>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-27" data-mp="3r5ylr980acra">{bonus.body}</p>
              <p className="mt-1.5 font-display text-xs font-extrabold uppercase tracking-wide text-navy" data-id="element-28" data-mp="3n6g1mfo0e5pi">
                Valeur :{' '}
                <span className="text-steel line-through decoration-alert decoration-2" data-id="element-29" data-mp="2zhezfa5rrqso">
                  {bonus.value}
                </span>{' '}
                <span className="text-teal" data-id="element-30" data-mp="38hbhgsxnlrer">inclus</span>
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}